export default {
      id: "ic_down_direction-usage",
      viewBox: "0 0 14 14",
      url: "/" + "images/icons.3.109.2.svg#ic_down_direction-usage",
      toString: function () {
        return this.url;
      }
    }